import { put, takeEvery, all } from 'redux-saga/effects';

import * as logger from '../utils/logger';
import getBaseUrl from '../utils/base-url';
import { companyId } from '../utils/variables';

export const SUBMIT_DESIGN_REQUEST = 'submit-design/SUBMIT_DESIGN_REQUEST';
export const SUBMIT_DESIGN_RESPONSE = 'submit-design/SUBMIT_DESIGN_RESPONSE';
export const SUBMIT_DESIGN_FAIL = 'submit-design/SUBMIT_DESIGN_FAIL';

export default {
  submitDesign: payload => ({
    type: SUBMIT_DESIGN_REQUEST,
    payload
  })
};

function* submitDesign(action) {
  try {
    const { payload } = action;

    const url = getBaseUrl() + '/companies/' + companyId + '/widget_responses';
    const res = yield fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'Application/json' },
      body: JSON.stringify({
        data: {
          attributes: {
            design_id: payload.designId,
            email: payload.email,
            first_name: payload.firstName,
            last_name: payload.lastName,
            phone: payload.phone,
            day: payload.day,
            month: payload.month,
            year: payload.year,
            main_text: payload.mainText
          }
        }
      })
    });

    if (res.status !== 201) {
      yield put({
        type: SUBMIT_DESIGN_FAIL
      });
      const text = yield res.text();
      logger.error(new Error('Can not submit a design: ' + text));
      return;
    }

    yield put({
      type: SUBMIT_DESIGN_RESPONSE,
      payload: {}
    });
  } catch (e) {
    yield put({
      type: SUBMIT_DESIGN_FAIL
    });
    logger.error(e);
  }
}

export function* submitDesignSaga() {
  yield all([takeEvery(SUBMIT_DESIGN_REQUEST, submitDesign)]);
}



// WEBPACK FOOTER //
// ./src/actions/submit-design.js